import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as galleryReducer from "containers/Gallery/GalleryReducer";
import * as viewReducer from "containers/View/reducer";
import * as transformReducer from "containers/Dataset/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as reportReducer from "containers/Report/ReportReducer";
import * as nextReducer from "containers/Next/NextReducer";
import * as setupReducer from "containers/Setup/reducer";
import * as globalReducer from "containers/App/reducer";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import Gallery from "components/Gallery/Gallery";

const getId = (props) =>
  props && props.datasetId
    ? props.datasetId
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

const getJId = (props) =>
  props && props.match && props.match.params && props.match.params.jId ? props.match.params.jId : undefined;

class GalleryContainer extends React.Component {
  constructor(props) {
    super(props);

    props.init();
  }

  render() {
    const { id, setupId, runId, dataset, isLoading } = this.props;

    if (dataset === undefined || isLoading) {
      return <LoadingIndicator />;
    }

    return <Gallery {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);
  const jId = getJId(ownProps);

  return {
    init: () => dispatch(galleryReducer.init(id, jId, ownProps.isNext)),
    changeDatasetName: (name) => dispatch(homeReducer.changeDatasetName(id, name)),
    updateRightMode: (mode) => dispatch(galleryReducer.updateRightMode(id, mode)),
    updateViewField: (viewField) => dispatch(galleryReducer.updateViewField(id, viewField)),
    updateViewOutcome: (viewOutcome) => dispatch(galleryReducer.updateViewOutcome(id, viewOutcome)),
    updateCombineDataset: (combineDataset) => dispatch(galleryReducer.updateCombineDataset(id, combineDataset)),
    updateAppendDataset: (appendDataset) => dispatch(galleryReducer.updateAppendDataset(id, appendDataset)),
    updateLookupKey: (index, lookupKey) => dispatch(galleryReducer.updateLookupKey(id, index, lookupKey)),
    updateFilter: (index, filter) => dispatch(galleryReducer.updateFilter(id, index, filter)),
    updateJoinType: (joinType) => dispatch(galleryReducer.updateJoinType(id, joinType)),
    updateAttachedBlueprint: (blueprintId, isAttached) =>
      dispatch(galleryReducer.updateAttachedBlueprint(id, blueprintId, isAttached)),
    updateAttachedBlueprintId: (blueprintId) => dispatch(galleryReducer.updateAttachedBlueprintId(id, blueprintId)),
    updateColumnBlueprintId: (blueprintId) => dispatch(galleryReducer.updateColumnBlueprintId(id, blueprintId)),
    updateMatchedColumn: (datasetColumn, blueprintColumn) =>
      dispatch(galleryReducer.updateMatchedColumn(id, datasetColumn, blueprintColumn)),
    updateIsPin: (isPin) => dispatch(galleryReducer.updateIsPin(id, isPin)),
    updateAddChartId: (addChartId) => dispatch(galleryReducer.updateAddChartId(id, addChartId)),
    updateSortField: (sortField) => dispatch(galleryReducer.updateSortField(id, sortField)),
    updateIsBlueprintSaved: (isBlueprintSaved) => dispatch(galleryReducer.updateIsBlueprintSaved(id, isBlueprintSaved)),
    addExploreOutcome: (outcome, fakeTime) => dispatch(galleryReducer.addExploreOutcome(id, outcome, fakeTime)),
    removeExploreOutcome: (outcome) => dispatch(galleryReducer.removeExploreOutcome(id, outcome)),
    updateOutcomeSuccess: (outcome) => dispatch(galleryReducer.updateOutcomeSuccess(id, outcome)),
    createAI: (outcome, success) => dispatch(galleryReducer.createAI(id, outcome, success)),
    saveChanges: () => dispatch(galleryReducer.saveChanges(id)),
    saveBlueprintMatches: (isDelete) => dispatch(galleryReducer.saveBlueprintMatches(id, isDelete)),

    changeOutcome: (outcome) => dispatch(homeReducer.changeOutcome(id, outcome)),
    updateColumnDescriptionDataset: (index, column, description) =>
      dispatch(homeReducer.updateColumnDescription(id, index, column, description)),

    updateType: (type) => dispatch(viewReducer.updateType(type)),

    createReport: (label, chart) => dispatch(reportReducer.createReport(label, id, chart)),
    addChartToReport: (reportId, chart) => dispatch(reportReducer.addChartToReport(reportId, id, chart)),
    createLinkedReport: (report) => dispatch(reportReducer.createLinkedReport(report)),
    updateActiveTab: (activeTab) => dispatch(nextReducer.updateActiveTab(ownProps.nextId, activeTab)),
    updateTargetValue: (targetValue) => dispatch(homeReducer.updateTargetValue(id, targetValue))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const columnBlueprintId = galleryReducer.getColumnBlueprintId(state, id);

  const isConsumer = ownProps.isConsumer;
  const correlations = setupReducer.getCorrelationMetricsFromDataset(state, ownProps.runId) || {};

  return {
    id: id,

    rightMode: galleryReducer.getRightMode(state, id),
    viewField: galleryReducer.getViewField(state, id),
    viewOutcome: galleryReducer.getViewOutcome(state, id),
    combineDataset: galleryReducer.getCombineDataset(state, id),
    appendDataset: galleryReducer.getAppendDataset(state, id),
    lookupKeys: galleryReducer.getLookupKeys(state, id),
    joinType: galleryReducer.getJoinType(state, id),
    filters: galleryReducer.getFilters(state, id),
    attachedBlueprints: galleryReducer.getAttachedBlueprints(state, id),
    attachedBlueprintId: galleryReducer.getAttachedBlueprintId(state, id),
    columnBlueprintId: galleryReducer.getColumnBlueprintId(state, id),
    matchedColumns: galleryReducer.getMatchedColumns(state, id),
    isSaving: galleryReducer.getIsSaving(state, id),
    isPin: galleryReducer.getIsPin(state, id),
    addChartId: galleryReducer.getAddChartId(state, id),
    isBlueprintSaved: galleryReducer.getIsBlueprintSaved(state, id),
    isBlueprintSaving: galleryReducer.getIsBlueprintSaving(state, id),
    exploreOutcomes: galleryReducer.getExploreOutcomes(state, id),
    ignoreOutcomes: galleryReducer.getIgnoreOutcomes(state, id),
    outcomeSuccess: galleryReducer.getOutcomeSuccess(state, id),
    hasUpdatedOutcomeSuccess: galleryReducer.hasUpdatedOutcomeSuccess(state, id),
    sortField: isConsumer ? undefined : galleryReducer.getSortField(state, id),
    highlightField: galleryReducer.getHighlightField(state, id),
    isDatasetUpdating: galleryReducer.getIsDatasetUpdating(state, id),
    isExploring: galleryReducer.getIsExploring(state, id),
    isCreatingLinkedReport: galleryReducer.getIsCreatingLinkedReport(state, id),

    blueprintColumnDescriptions: blueprintReducer.getAllColumnDescription(state, columnBlueprintId),

    datasets: viewReducer.getDatasets(state),
    blueprints: viewReducer.getBlueprints(state),

    transform: transformReducer.getTransform(state, id),

    dataset: homeReducer.getDataset(state, id),
    descriptions: homeReducer.getDescriptions(state, id),
    reports: reportReducer.getReports(state),
    linkedReports: reportReducer.getReportsFromDatasetId(state, id),

    analyzedOutcomes: homeReducer.getAnalyzedOutcomes(state, id),
    aiReadyOutcomes: homeReducer.getAiReadyOutcomes(state, id),

    canEdit: homeReducer.getUserEditPermission(state, id),
    canManagePermissions: homeReducer.getUserManagePermissions(state, id),

    linkedSchemaChanges: homeReducer.getLinkedSchemaChanges(state, id),
    linkedSchenaMonitor: homeReducer.getLinkedSchemaMonitor(state, id),
    dataSourceDetails: homeReducer.getDatasetSourceDetails(state, id),
    isLinkedDataset: homeReducer.getIsLinkedDataset(state, id),

    isLoading: globalReducer.getIsBlueprintsLoading(state),

    activeTab: nextReducer.getActiveTab(state, ownProps.nextId),
    correlations: correlations
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(GalleryContainer);
